"use client";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import Chevron from "@workspace/casino_pages/legacyLayer/external/icons/Chevron";
import type { FC, ReactNode } from "react";
import useToggle from "@/client/hooks/useToggle";

type Props = {
  title: ReactNode;
  isBitcasino: boolean;
  topSectionFontClass?: string;
  children?: ReactNode;
};

const NavItem: FC<Props> = ({
  title,
  isBitcasino,
  children,
  topSectionFontClass = "[&_a]:text-muted-foreground",
}) => {
  const [showList, onToggle] = useToggle();

  return (
    <div
      data-nav-item
      className={classNames(
        "relative grid h-11 content-start overflow-hidden rounded-md bg-secondary p-3 transition-[height] duration-200 ease-in-out 2xl:h-full 2xl:rounded-none 2xl:bg-transparent 2xl:p-0",
        showList && "h-full",
      )}
    >
      <div
        className="mb-4 grid cursor-pointer grid-cols-[1fr_auto] 2xl:cursor-default 2xl:[&_svg]:hidden"
        onClick={onToggle}
      >
        <h6>{title}</h6>
        <Chevron arrow={showList ? "up" : "down"} />
      </div>

      <div
        className={classNames(
          topSectionFontClass,
          "[&_a]:no-underline [&_a]:hover:text-primary [&_nav]:grid [&_nav]:justify-start [&_nav]:gap-4",
          isBitcasino && "[&_a]:text-xs",
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default NavItem;
